import React, { useState, useEffect } from 'react';
import { Button, Alert, Row, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { useLocation} from 'react-router-dom';


interface PurchaseData {
  productName?: string;
  productId?: string;
  value: number;
  currency?: string;
}

const CanvaBack = () => {
	
	const location=useLocation();
	
	const [error, setError] = useState<string | null>(null);
  
	useEffect(() => {
    // Parse query parameters from the location object
    const queryParams = new URLSearchParams(location.search);
    const errorParam = queryParams.get('error');
    const sessionId = queryParams.get('session_id'); // Stripe success parameter
    const success = queryParams.get('success');

    // Check if the error parameter is set to 12
    if (errorParam === '12') {
      setError('Your session has expired. Please go back to Canva and restart.');
    } else {
      setError(null);
    }

    // Track Purchase event for Meta Pixel if this is a successful conversion
    if ((sessionId || success === 'true') && typeof window !== 'undefined' && (window as any).fbq) {
      // Try to get purchase data from localStorage (stored before Stripe redirect)
      let purchaseData: PurchaseData | null = null;
      if (window.localStorage) {
        const storedData = window.localStorage.getItem('pendingPurchase');
        if (storedData) {
          try {
            const parsed = JSON.parse(storedData) as PurchaseData;
            purchaseData = parsed;
            // Clear the stored data after reading
            window.localStorage.removeItem('pendingPurchase');
          } catch (e) {
            console.error('Failed to parse purchase data from localStorage', e);
          }
        }
      }

      // Always track Purchase event, but only include value/currency if we have price data
      const purchaseParams: any = {
        content_name: purchaseData?.productName || 'Subscription Purchase',
        content_category: 'Purchase'
      };

      // Only add value and currency if we have valid price data (and it's not 0)
      if (purchaseData && purchaseData.value !== undefined && purchaseData.value > 0) {
        purchaseParams.value = purchaseData.value;
        purchaseParams.currency = purchaseData.currency || 'USD';
      }

      // Add product ID if available
      if (purchaseData?.productId) {
        purchaseParams.content_ids = [purchaseData.productId];
      }

      (window as any).fbq('track', 'Purchase', purchaseParams);
    }
  }, [location.search]); // Re-run the effect if the search part of the URL changes


  return (
    <>
      <Helmet>
        <title>AI Music</title>
      </Helmet>
      
 
      <Row className="p-2">
      {error && <Alert variant="danger">{error}</Alert>}     
      <Button onClick={()=>window.close()} variant="primary">Back to Canva</Button>
      </Row>
    </>
  );
};

export default CanvaBack;
